// All Recliners Ready-to-ship functionality
// Based on the exact same logic as Admiral implementation

document.addEventListener('DOMContentLoaded', function () {

function getCurrentSelections() {
  return {
    cLeatherColor: $('div#bcpo-select-option-1 input:checked').val() || '',
    cWoodColor: $('.selector-wrapper.bcpo-simple.bcpo-images input:checked').eq(1).val() || '',
    cBase: $('div#bcpo-select-option-2 input:checked').val() || '',
    cSize: $('div#bcpo-select-option-0 input:checked').val() || ''
  };
}

function updateButtonState() {
  const { cLeatherColor, cWoodColor, cBase, cSize } = getCurrentSelections();
  const $submitBtn = $('.match-found-link');
  const $standardButton = $('.product-form__submit, button[name="add"], button[type="submit"]').not('.match-found-link');

  // Check if data is available
  if (!window.quickShipProductOptions || !window.currentProductBaseName) {
    // console.log('❌ Ready-to-ship data not loaded yet. Available:', {
    //   quickShipProductOptions: !!window.quickShipProductOptions,
    //   currentProductBaseName: window.currentProductBaseName,
    //   currentProductTitle: window.currentProductTitle
    // });
    return;
  }

  // Filter products to only match the current product's base name (Admiral, Mayfair, etc.)
  const currentBaseName = window.currentProductBaseName;
  const filteredOptions = window.quickShipProductOptions.filter(option => 
    option.base_product_name === currentBaseName
  );

  const match = filteredOptions.find(option =>
    cLeatherColor.includes(option.leather_color) &&
    option.wood_color === cWoodColor &&
    option.base === cBase &&
    option.size === cSize
  );

  // console.log('Ready-to-ship Debug:', {
  //   currentProduct: window.currentProductTitle,
  //   currentBaseName: currentBaseName,
  //   totalOptions: window.quickShipProductOptions ? window.quickShipProductOptions.length : 0,
  //   filteredOptions: filteredOptions.length,
  //   selections: { cLeatherColor, cWoodColor, cBase, cSize },
  //   match: match,
  //   hasInventory: match ? match.inventory : 'no match'
  // });

  if (match && match.inventory > 0) {
    // Show ready-to-ship button
    $submitBtn.removeClass('sold-out').prop('disabled', false).text('Add to Cart');
    $submitBtn.attr('href', `/cart/add?id=`+match.variant_id+`&quantity=1`);
    jQuery('.product__info-wrapper').addClass('match-found');
    jQuery('.featured-admiral').addClass('match-found');
    jQuery('product-form').addClass('match-found');
    
    // FORCE hide standard button with multiple approaches
    $standardButton.hide();
    $submitBtn.show().css('display', 'flex');
    
    // Extra aggressive hiding
    jQuery('.product-form__buttons button').not('.match-found-link').hide();
    jQuery('.shopify-payment-button').hide();
    
  } else if (match && match.inventory <= 0) {
    // Show sold out ready-to-ship button
    $submitBtn.addClass('sold-out').prop('disabled', true).text('Sold Out');
    jQuery('.product__info-wrapper').removeClass('match-found');
    jQuery('.featured-admiral').removeClass('match-found');
    jQuery('product-form').removeClass('match-found');
    
    // Show standard button, hide ready-to-ship
    $standardButton.show();
    $submitBtn.hide();
    jQuery('.shopify-payment-button').show();
    
  } else {
    // No match - show standard button only
    $submitBtn.removeClass('sold-out').prop('disabled', false).text('Add to Cart');
    jQuery('.product__info-wrapper').removeClass('match-found');
    jQuery('.featured-admiral').removeClass('match-found');
    jQuery('product-form').removeClass('match-found');
    
    // Show standard button, hide ready-to-ship
    $standardButton.show();
    $submitBtn.hide();
    jQuery('.shopify-payment-button').show();
  }
}

// Start checking after a short delay to ensure data is loaded
setTimeout(() => {
  updateButtonState(); // Check immediately after delay
  setInterval(updateButtonState, 1000); // Then check every second
}, 500);

});

// Smooth scroll functionality for ready-to-ship anchor links
document.querySelectorAll('a[href^="#ready-to-ship"]').forEach(anchor => {
    anchor.addEventListener('click', function(e) {
      e.preventDefault();
      const target = document.querySelector(this.getAttribute('href'));
      if (target) {
        const offset = 100;
        const top = target.getBoundingClientRect().top + window.pageYOffset - offset;
        window.scrollTo({ top, behavior: 'smooth' });
      }
    });
}); 